import Vue from 'vue';

import { AppointmentService } from "@/api";
import {
    APPOINTMENT_FETCH,
    APPOINTMENT_BOOKED,
    APPOINTMENT_BOOK,
    APPOINTMENT_CANCEL,
    APPOINTMENT_CANCEL_KAM,
    APPOINTMENT_BLOCK,
} from "@/store/actions.type";

import {
    FETCH_START,
    FETCH_END,
    BOOK_START,
    BOOK_END,
    CANCEL_START,
    CANCEL_END,
    SET_APPOINTMENT,
    SET_APPOINTMENT_BOOKING,
    SET_BOOKED_APPOINTMENT,
    SET_APPOINTMENT_CANCELLED,
    SET_KAM,
    SET_APPOINTMENTS_BLOCKED,
    SET_APPOINTMENT_KAM_CANCELLED,
} from "@/store/mutations.type";

const state = () => ({
    isLoading: false,
    isBooking: false,
    isCancelling: false,
    kam: '',
    appointment: null,
    plusone: '',
    note: '',
    appointments: {},
});

const actions = {

    async [APPOINTMENT_FETCH]({ commit, state }, kamEmail) {

        if (state.appointments.hasOwnProperty(kamEmail)) {
            commit(SET_KAM, kamEmail);
            return state.appointments[kamEmail];
        }

        commit(FETCH_START);

        try {
            const { data } = await AppointmentService.get(kamEmail);
            commit(SET_APPOINTMENT, {
                data: data.data,
                kamEmail
            });

            return data;

        } catch(e) {
            commit(FETCH_END);
        }

        return null;
    },

    async [APPOINTMENT_BOOKED]({ commit, state }) {

        commit(FETCH_START);

        try {
            const { data } = await AppointmentService.getBookedAppointments();
            commit(SET_BOOKED_APPOINTMENT, data);

            return data;

        } catch(e) {
            commit(FETCH_END);
        }

        return null;
    },

    async [APPOINTMENT_BOOK]({ commit, state }, bookingData) {

        if (state.isBooking) {
            return;
        }

        commit(BOOK_START);

        try {

            const { data } = await AppointmentService.book(bookingData);
            if (data.success) {
                commit(SET_APPOINTMENT_BOOKING, bookingData);
            } else {
                commit(BOOK_END);
            }

            return data;

        } catch(e) {
            commit(BOOK_END);
        }

        return {
            success: false
        };
    },

    async [APPOINTMENT_CANCEL]({ commit, state }, cancelationData) {

        if (state.isCancelling) {
            return;
        }

        commit(CANCEL_START);

        try {
            const { data } = await AppointmentService.cancel(cancelationData);

            if (data.success) {
                commit(SET_APPOINTMENT_CANCELLED);
            } else {
                commit(CANCEL_END);
            }



        } catch(e) {
            commit(CANCEL_END);
        }

        return {
            success: false
        };
    },

    async [APPOINTMENT_CANCEL_KAM]({ commit, state }, cancelationData) {

        if (state.isCancelling) {
            return;
        }

        commit(CANCEL_START);

        try {
            const { data } = await AppointmentService.cancel(cancelationData);

            if (data.success) {
                commit(SET_APPOINTMENT_KAM_CANCELLED, cancelationData);
            } else {
                commit(CANCEL_END);
            }



        } catch(e) {
            commit(CANCEL_END);
        }

        return {
            success: false
        };
    },

    async [APPOINTMENT_BLOCK]({ commit, state }, blockData) {

        if (state.isBooking) {
            return;
        }

        commit(BOOK_START);

        try {
            const { data } = await AppointmentService.block(blockData);

            if (data.success) {
                commit(SET_APPOINTMENTS_BLOCKED, {
                    blockedAppointments: blockData.blockedAppointments,
                    unblockedAppointments: blockData.unblockAppointments,
                });
            } else {
                commit(BOOK_END);
            }

        } catch(e) {
            commit(BOOK_END);
        }

        return {
            success: false
        };
    },

};

const mutations = {

    [FETCH_START](state) {
        state.isLoading = true;
    },

    [FETCH_END](state) {
        state.isLoading = false;
    },

    [BOOK_START](state) {
        state.isBooking = true;
    },

    [BOOK_END](state) {
        state.isBooking = false;
    },

    [CANCEL_START](state) {
        state.isCancelling = true;
    },

    [CANCEL_END](state) {
        state.isCancelling = false;
    },

    [SET_KAM](state, kamEmail) {
        state.kam = kamEmail;
    },

    [SET_APPOINTMENT](state, { data, kamEmail }) {

        state.isLoading = false;
        state.kam = kamEmail;
        state.appointments[kamEmail] = data;
    },

    [SET_BOOKED_APPOINTMENT](state, data) {

        state.isLoading = false;
        state.appointment = data.appointment;
        state.kam = data.kam;
        state.note = data.note;
        state.plusone = data.plusone;
    },

    [SET_APPOINTMENT_BOOKING](state, data) {

        state.isBooking = false;

        const appointments = [
            ...state.appointments[data.kam],
            { appointment: data.appointment }
        ];

        Vue.set(state, 'appointments', {
            [data.kam]: appointments
        });

        state.appointment = data.appointment;
        state.kam = data.kam;
    },

    [SET_APPOINTMENT_CANCELLED](state) {

        state.isCancelling = false;

        const appointments = state.appointments[state.kam].filter((item) => {
            return item.appointment != state.appointment;
        });

        Vue.set(state, 'appointments', {
            [state.kam]: appointments
        });

        state.appointment = null;
    },

    [SET_APPOINTMENT_KAM_CANCELLED](state, data) {

        state.isCancelling = false;

        const appointments = state.appointments[state.kam].filter((item) => {
            return item.appointment != data.appointment;
        });

        Vue.set(state, 'appointments', {
            [state.kam]: appointments
        });

        state.appointment = null;
    },

    [SET_APPOINTMENTS_BLOCKED](state, { blockedAppointments, unblockedAppointments }) {

        state.isBooking = false;

        const filteredState = state.appointments[state.kam].filter((item) => {
            return unblockedAppointments.map((unblockItem) => unblockItem.appointment).indexOf(item.appointment) === -1;
        });


        let allAppointments = [
            ...filteredState,
            ...blockedAppointments
        ];

        allAppointments = allAppointments.filter((item, pos) => {
            return allAppointments.indexOf(item) == pos;
        });

        Vue.set(state, 'appointments', {
            [state.kam]: allAppointments
        });

        state.appointment = null;
    },
};

const getters = {
    isLoading: (state) => {
        return state.isLoading;
    },

    isBooking: (state) => {
        return state.isBooking;
    },

    isCancelling: (state) => {
        return state.isCancelling;
    },

    getAppointments: (state) => {

        if (!state.appointments[state.kam]) { return null; }

        return state.appointments[state.kam].map(item => item.appointment);
    },

    getAppointmentTypeMap: (state) => {
        if (!state.appointments[state.kam]) { return null; }

        return state.appointments[state.kam].reduce((value, item) => {
            return {
                ...value,
                [item.appointment]: item.type
            };
        }, {});
    },

    getUserAppointment: (state) => {
        return state.appointment;
    },

    getKam: (state) => {
        return state.kam;
    },

    getNote: (state) => {
        return state.note;
    },

    getPlusOne: (state) => {
        return state.plusone;
    },

    getAppointmentData: (state) => {
        if (!state.appointments[state.kam]) { return null; }

        return state.appointments[state.kam].reduce((value, item) => {
            return {
                ...value,
                [item.appointment]: {
                    note: item.note,
                    participant: item.participant,
                    plusone: item.plusone
                }
            };
        }, {});
    },

};


export const appointment = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
